import React, { useState, useEffect, useContext, useRef } from "react";
import { DeviceContext } from "context/deviceProvider";
import { useParams } from "react-router-dom";
import { Breadcrumb } from "semantic-ui-react";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/deviceData/realtimeDevice.scss";
import LetterLoading from "components/loading/letterLoading";
import { Divider, Header, Icon, Segment, Form } from "semantic-ui-react";
import GoogleMapsDevicesIot from "components/homepage/googleMapsDevicesIot";
// import ApiData from 'screens/deviceData/getApiDevice';
import axios from 'axios';

const RealtimeDevice = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [deviceDataDevice, setDeviceData] = useState(null);
  const [deviceDataClient, setClientData] = useState(null);
  const [machineLocationList, setMachineLocation] = useState([]);
  const [DataHitory, setDataHitory] = useState([]);
  const context = useContext(DeviceContext);
  const API_URL = 'https://clp-service.honey.co.th';
  const ACCESS_TOKEN = 'e2b1e20a-b26a-4d3b-9c80-8ea29c05f046';
  const iotSerial = id;
  const iotSerials = "7C:9E:BD:50:02:C8";

  // เช็ค DataClient ถ้ามีข้อมูลให้ไปดึง api จาก device
  const fetchDataClient = async () => {
    const responseClient = await axios.get(`${API_URL}/mqtt/client/${iotSerial}`, {
      headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
    });
    if (responseClient.data.data && responseClient.data.data.connectedAt != null) {
        console.log("DataClient",responseClient.data.data)
        setClientData(responseClient.data.data);

        if (responseClient.data.data  != null ) {
          const fetchDataDevice = async () => {
            const deviceResponse = await axios.get(`${API_URL}/mqtt/device/${iotSerial}`, {
              headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
            });
            if (deviceResponse.data.data) {
              setDeviceData(deviceResponse.data.data);
            }
            console.log("deviceResponse",deviceResponse.data.data)
          };
          fetchDataDevice(); // เรียกใช้ฟังก์ชัน fetchDataDevice() เพื่อดึงข้อมูลจาก API
        }
    }
    console.log("DataClients",responseClient.data.data)
    //fetchDataClient();  
  };

  // ดึงข้อมูล Location จากฐานข้อมูล
  const getMachineLocation = async () => {
    const machineLocationData = await context.machineLocation({ iotSerials: iotSerial });
    console.log("Data", machineLocationData);

    if (machineLocationData != null) {
      setMachineLocation(machineLocationData);
    }
  }
  
  const getMachineHitory = async () => {
    const clpMemberListAll = await context.getClpMemberAll();
    const responseMachineHitory = await axios.get(`${API_URL}/mqtt/client/${iotSerial}`, {
      headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
    });
    console.log("MachineHitory",responseMachineHitory.data.data)

    const deviceHitory = clpMemberListAll.filter(de => de.is_delete === 0 && de.device_serial === iotSerial);
    // console.log("deviceHitory", deviceHitory);
    
    // ตรวจสอบว่ามีข้อมูลใน deviceHitory ก่อนเรียกใช้
    if (deviceHitory.length > 0) {
      const deviceBuy_Date = deviceHitory[0].devicebuy_date;  // ดึง devicebuy_date จาก object แรกใน deviceHitory
    
      const parts = deviceBuy_Date.split(' ')[0].split('-');  // แยกวันที่ (เช่น "2024-01-01 00:00:00")
      const year = parseInt(parts[0], 10);  // ปี
      const month = parseInt(parts[1], 10); // เดือน
      const day = parseInt(parts[2], 10);   // วัน
    
      const startDateTime = new Date(year, month - 1, day);  // month ใน JavaScript ต้องลด 1 (0 = January)
      const timestampDateStart = Math.floor(startDateTime.getTime() / 1000);  // แปลงเป็น timestamp วินาที
    
      const DateEnd = new Date();
      const timestampDateEnd = Math.floor(DateEnd.getTime() / 1000);  // แปลงเป็น timestamp วินาทีปัจจุบัน
 
      const responseHitory = await axios.get(`${API_URL}/data/${iotSerial}`, {
        params: {
          startTime: timestampDateStart,
          endTime: timestampDateEnd,
        },
        headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
      });

      if (responseHitory.status === 200) {
        const jsonResponse = responseHitory.data;
      
        if (jsonResponse.success === true && jsonResponse.data && jsonResponse.data.length > 0) {
          // เข้าถึงข้อมูลล่าสุด (สุดท้ายของอาร์เรย์)
            const deviceDataHitory = jsonResponse.data[jsonResponse.data.length - 1];

            console.log("deviceDataHitory", deviceDataHitory);
          // ดึงค่าจากข้อมูลล่าสุด
            const { current, lat, lng, meter, power, signal, dt, ts } = DataHitory;

            // แสดงค่าต่างๆ
            console.log('Current:', current);
            console.log('Latitude:', lat);
            console.log('Longitude:', lng);
            console.log('Meter:', meter);
            console.log('Power:', power);
            console.log('Signal:', signal);
            console.log('Date Time:', dt);
            console.log('Timestamp:', ts);

            if (deviceDataHitory != null) {
              setDataHitory(deviceDataHitory);
           }
        }  
      } 
    } 
  }

  useEffect(() => {
    setIsLoading(true);
    fetchDataClient();
    getMachineHitory();
    getMachineLocation();
    setTimeout(() => setIsLoading(false), 1000);
    // fetchDataDevice();    
  }, [props.data]);
  const detailDate = (content1, content2) => {
    return (
      <table className="detail">
        <tbody>
          <tr>
            <td>{content1}</td>
            <td>{content2}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  const detailDates = (content2) => {
    const style = {
      animation: content2 === 1 ? 'blink-green 1s infinite' : 'none',
      color: 'red',
    };
    return (
      <table className="detail">
        <tbody style={style}>
          {content2 === 1 ? 'เครื่องจักรกำลังทำงาน' : 'เครื่องจักรหยุดการทำงาน'}
        </tbody>
      </table>
    );
  };

  function formatDuration(meter) {
    const hours = Math.floor(meter / 3600); // คำนวณชั่วโมงจากจำนวนวินาที
    const minutes = Math.floor((meter % 3600) / 60); // คำนวณนาทีจากจำนวนวินาที
    const seconds = meter % 60; // คำนวณวินาทีจากจำนวนวินาที
    return `${hours} ชั่วโมง ${minutes} นาที ${seconds} วินาที`;
  }

  function formatDate(connectedAt) {
    const date = new Date(connectedAt);
    if (!date || new Date(date).getFullYear() < 2020) {
      return '-'; // คืนค่าว่างถ้าไม่มีค่าหรือปีน้อยกว่า 2020
    }
    else {
      const formattedDateTime = date.toLocaleString();
      return formattedDateTime;
    }
  }

  const getDataDevice = () => {
    // fetchDatasClient();
    return (
      <div className="maintenanceAdd">
        <div className="maintenanceAdd-topic">
          <Divider horizontal>
            <Header as="h3">
              <Icon name="file alternate outline" />
              รายละเอียดการทำงานของเครื่องจักร
            </Header>
          </Divider>
        </div>
        <Segment>
          <table className="add">
            <tbody>
              <tr>
                {/* <p>หมายเลขอุปกรณ์ IoT: {iotSerial}</p> */}
                {/* <td>{detailDate("หมายเลขเครื่องจักร :", id)}</td> */}
                <td>{detailDate("หมายเลขอุปกรณ์ IoT :", iotSerial)}</td>
              </tr>
              <tr>
                <td>{detailDate("ชั่วโมงการทำงานทั้งหมด :", formatDuration(DataHitory?.meter))}</td>
                <td>{detailDate("ค่ามิเตอร์ไฟฟ้า (กิโลวัตต์/วินาที) :", ((220 * DataHitory?.current) / 1000).toFixed(3))}</td>
              </tr>
              <tr>
                <td>{detailDate("ค่ากระแสไฟฟ้า (แอมป์) :", DataHitory?.current == null ? "-" : DataHitory?.current)}</td>
                <td>{detailDate("ค่าสัญญาณที่ได้รับจากอุปกรณ์ :", DataHitory?.signal == null ? "-" : DataHitory?.signal)}</td>
              </tr>

              <tr>
                <td>{detailDate("ละติจูด :", DataHitory?.lat ?? machineLocationList?.machines?.[0]?.lat ?? "-")}</td>
                <td>{detailDate("ลองจิจูด :", DataHitory?.lng ?? machineLocationList?.machines?.[0]?.long ?? "-")}</td>
              </tr>

              <tr>
                <td>{detailDate("IP Address :", deviceDataClient?.ipAddress == null ? "-" : deviceDataClient?.ipAddress)}</td>
                <td>{detailDate("วันที่และเวลาที่เชื่อมต่อล่าสุด :", formatDate(DataHitory?.dt))}</td>
              </tr>

              <tr>
              </tr>
            </tbody>
          </table>
        </Segment>
        {/* <ApiData /> */}
      </div>
    );
  }

  const getMapDevice = () => {
    return (
      <div className="maintenanceAdd">
        <div className="maintenanceAdd-topic">
          <Divider horizontal>
            <Header as="h3">
              <Icon name="file alternate outline" />
              สถานที่ตั้งของเครื่องจักร
            </Header>
          </Divider>
        </div>
        <Segment>
          <GoogleMapsDevicesIot data={deviceDataDevice} power={deviceDataDevice?.power === 1 ? 1 : 0}
            lat={deviceDataDevice?.lat ?? machineLocationList?.machines?.[0]?.lat ?? 0}
            lng={deviceDataDevice?.lng == null ? 102.371 : deviceDataDevice?.lng} />
        </Segment>
      </div>
    );
  }

  const sections = [
    { key: "หน้าแรก", content: <a href="/home">หน้าแรก</a>, link: true },
    { key: "Machine Profile", content: <a href="/machine-list">Machine Profile</a>, link: true, },
    { key: `${id}`, content: `${id}`, active: true, },
  ];

  return (
    <div className="realtime-device">
      <LetterLoading isOpen={isLoading} />
      <Sidebar tabActive="deviceData" reports="machineList" />
      <Navigation />

      <div className="machineProfile-content">
        <h2> ข้อมูลการทำงานของเครื่องจักร : {id} </h2> {detailDate("สถานะการทำงาน :", detailDates(deviceDataDevice?.power))} <hr />
        <Breadcrumb icon="right angle" sections={sections} />
        <div className="machineProfile-content-inform">{getDataDevice()}</div>
        <div> {getMapDevice()} </div>
      </div>
    </div>
  );
}
export default RealtimeDevice;
